import Button from '@/common/components/Button'
import { EstablishmentTechnicalProfessionalData } from '@/common/types/establishmentTechnicalProfessional'
import { ArrowBigRight, UserCog } from 'lucide-react'
import { Link } from 'react-router-dom'

export class EstablishmentTechnicalProfessionalsTransformer {
  static tableTransformer() {
    return (establishmentTechnicalProfessionals: EstablishmentTechnicalProfessionalData[]) => {
      return establishmentTechnicalProfessionals.map((establishmentTechnicalProfessional) => {
        return {
          ...establishmentTechnicalProfessional,
          action: (
            <Link to={`/establishment-technical-professionals/${establishmentTechnicalProfessional.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Maintenance::EstablishmentTechnicalProfessionals::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }

  static optionsTransformer() {
    return (establishmentTechnicalProfessionals: EstablishmentTechnicalProfessionalData[]) => {
      return establishmentTechnicalProfessionals.map((establishmentTechnicalProfessional) => {
        return {
          value: establishmentTechnicalProfessional.id,
          label: establishmentTechnicalProfessional.display_name,
          icon: <UserCog strokeWidth={1} size={20} />
        }
      })
    }
  }
}
